// extracted by css-extract-rspack-plugin
export default {"answer":"_a39d03e3"};